import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DoCheck,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from "@angular/core";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../core/services/event-bus.service";

@Component({
    selector: "timesheet-grid",
    templateUrl: "./timesheet-grid.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimesheetGridComponent implements OnInit, DoCheck, OnDestroy {
    constructor(
        private _eventBusService: EventBusService,
        private viewContainerRef: ViewContainerRef,
        private _cd: ChangeDetectorRef
    ) {
        //  this._cd.detach();
    }
    sub = new SubSink();
    interval: any;
    masterData: any;
    buAccess: any;
    CHANGE_DETECTION_TIMEOUT = 30000;
    CHANGE_DETECTION_CYCEL = 300;
    @HostListener("document:click", ["$event"]) onClick() {
        clearInterval(this.interval);
        this.interval = setInterval(
            () => this._cd.detectChanges(),
            this.CHANGE_DETECTION_CYCEL
        );
        if (this.interval)
            setTimeout(
                () => clearInterval(this.interval),
                this.CHANGE_DETECTION_TIMEOUT
            );
    }
    //@ViewChild("gridTemplate", { static: true })
    //gridTemplate;

    broadcastMasterData() {
        this._eventBusService.emit(
            new EmitEvent(
                "getData",
                "receiveBroadcastedMasterData",
                this.masterData
            )
        );
    }

    subscribeEventHandlers() {
        this.sub.sink = this._eventBusService.on(
            "onMasterDataReceived",
            (data) => {
                this.masterData = data;
                this.buAccess = data.buAccess;
                this.broadcastMasterData();
            }
        );
    }

    ngDoCheck() {
        // console.log("parent");
    }

    ngOnInit() {
        this.subscribeEventHandlers();

        this.interval = setInterval(
            () => this._cd.detectChanges(),
            this.CHANGE_DETECTION_CYCEL
        );
        setTimeout(() => {
            if (this.interval) clearInterval(this.interval);
        }, this.CHANGE_DETECTION_TIMEOUT);
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
